import { Link } from 'react-router-dom';
import { heroComics } from '@/mocks/homeMocks';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center">
      <div className="absolute inset-0 mx-4 md:mx-6 my-4 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20collage%20featuring%20multiple%20beautiful%20illustrated%20characters%20in%20dynamic%20poses%2C%20vibrant%20color%20palette%20with%20warm%20olive%20green%20and%20soft%20cream%20tones%2C%20artistic%20composition%20with%20floating%20manga%20panels%2C%20decorative%20Korean%20pattern%20elements%2C%20dreamy%20atmospheric%20lighting%2C%20clean%20aesthetic%2C%20modern%20editorial%20design%20with%20soft%20gradients&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="韩漫大全 - 韩国漫画在线阅读网 - 海量韩漫资源免费畅读"
          title="韩漫大全 - 韩国漫画在线阅读网"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 pb-20 flex flex-col items-center text-center">
        <span className="inline-block px-5 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white text-sm md:text-base font-medium mb-6">
          每日更新 · 免费畅读
        </span>

        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight tracking-wide max-w-4xl">
          韩漫大全
          <br />
          <span className="text-3xl md:text-5xl lg:text-6xl font-medium">
            韩国漫画在线阅读网
          </span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
          每日更新最新章节，提供海量韩漫资源，支持评论与收藏功能，让您随时随地畅享<strong>韩漫阅读</strong>乐趣
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
          <Link
            to="/category/all"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line mr-2"></i>
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border border-white/40 text-white font-medium text-sm md:text-base hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-6 max-w-3xl w-full">
          {heroComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={comic.coverImage}
                alt={comic.title}
                title={`${comic.title} - 韩漫大全免费阅读`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white font-heading font-bold text-sm md:text-base truncate">
                  {comic.title}
                </h3>
                <p className="text-white/70 text-xs mt-1">
                  {comic.latestChapter}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex items-center gap-6">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">50,000+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">漫画总数</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">1,000万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">累计用户</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">50+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">每日更新</div>
          </div>
        </div>
      </div>
    </section>
  );
}